import FormikInput from 'components/formikFields/input'
import Header from 'components/headers/wallet'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { Schema } from './utilities'
import SelectModal from 'components/modals/selectModal'
import useGetCards from 'pages/loans/withDraw/hooks/useGetCards'
import WithDrawWalletModal from 'components/modals/withDrawWallets'
import useSetAddUser from './hooks/useSetAddUser'
import useJoinLink from '../../../pages/fund/joinFundByLink/hooks/useJoinLink'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import DotsLoading from '../../../components/loadings/dotsLoading'
import posthog from 'posthog-js'
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
export default function AddNewUser() {
    const [isOpenGuarantor, setIsOpenGuarantor] = useState<boolean>(false)
    const [selectedGuarantor, setSelectedGuarantor] = useState<ISelectUser>()
    const [GuarantorId, setGuarantorId] = useState<undefined | number>()
    const [selectedBankNumber, setSelectedBankNumber] = useState<number>(0)
    const [isOpenRecommender, setIsOpenRecommender] = useState<boolean>(false)
    const { id } = useParams()
    const { joinLink, isLoadingJoinLink } = useJoinLink(id)
    const [selectedRecommender, setSelectedRecommender] =
        useState<ISelectUser>()
    const [RecommenderId, setRecommenderId] = useState<undefined | number>()
    useGetCards(
        selectedGuarantor?.id,
        selectedGuarantor?.memberId,
        setSelectedBankNumber
    )
    useGetCards(
        selectedRecommender?.id,
        selectedRecommender?.memberId,
        setSelectedBankNumber
    )

    const { mutate } = useSetAddUser()
    return (
        <>
            {!isLoadingJoinLink && joinLink ? (
                <>
                    <Formik
                        initialValues={{
                            phone_number: '',
                            number_of_shares: '1',
                            first_name: '',
                            last_name: '',
                        }}
                        validationSchema={Schema}
                        onSubmit={async (values) => {
                            const payload: IAddNewUserToFundPayload = {
                                moneyPool: id,
                                phone_number: values.phone_number,
                                first_name: values.first_name,
                                last_name: values.last_name,
                                number_of_shares: values.number_of_shares,
                                recommender: selectedRecommender?.id,
                                guarantor: selectedGuarantor?.id,
                            }
                            posthog.capture('member_add_submitted', {
                                fund_id: id,
                                number_of_shares: values.number_of_shares,
                                has_guarantor: Boolean(selectedGuarantor),
                                has_recommender: Boolean(selectedRecommender),
                            })
                            mutate(payload)
                        }}
                    >
                        <Form>
                            <div className=" h-screen flex flex-col">
                                <div className=" grow-0">
                                    <Header title="عضو جدید" />
                                </div>
                                <div className=" grow mt-32">
                                    <div className=" mx-3 mt-3 text-sm font-normal">
                                        <FormikInput
                                            type="number"
                                            label="شماره موبایل"
                                            name="phone_number"
                                            placeholder=""
                                            className="text-sm font-normal"
                                            isGray
                                            min={0}
                                        />
                                    </div>
                                    <div className=" mx-3 mt-4 text-sm font-normal grid grid-cols-3 gap-2">
                                        <div className=" col-span-1">
                                            <FormikInput
                                                type="text"
                                                label="نام"
                                                name="first_name"
                                                placeholder=""
                                                className="text-sm font-normal"
                                                isGray
                                            />
                                        </div>
                                        <div className=" col-span-2">
                                            <FormikInput
                                                type="text"
                                                label="نام خانوادگی"
                                                name="last_name"
                                                placeholder=""
                                                className="text-sm font-normal"
                                                isGray
                                            />
                                        </div>
                                    </div>
                                    <div className=" mx-3 mt-4 text-sm font-normal text-center items-center">
                                        <div className=" col-span-1">
                                            <FormikInput
                                                type="number"
                                                label="تعداد سهم"
                                                name="number_of_shares"
                                                placeholder=""
                                                className="text-sm font-normal"
                                                isGray
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                    <div className=" mx-3 mt-4 text-sm font-normal">
                                        <div
                                            className=" bg-transparent text-center w-full relative rounded-2xl py-3 border-1 border-gray-2"
                                            onClick={() =>
                                                setIsOpenGuarantor(true)
                                            }
                                        >
                                            <span className=" absolute right-5 -top-3 bg-white pl-1">
                                                نام ضامن عضو
                                            </span>
                                            {selectedGuarantor?.name ? (
                                                selectedGuarantor?.name
                                            ) : (
                                                <>
                                                    <p>اختیاری</p>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className=" mx-3 mt-4 text-sm font-normal">
                                        <div
                                            onClick={() =>
                                                setIsOpenRecommender(true)
                                            }
                                            className=" bg-transparent text-center w-full relative rounded-2xl py-3 border-1 border-gray-2"
                                        >
                                            <span className=" absolute right-5 -top-3 bg-white pl-1">
                                                نام معرف عضو
                                            </span>
                                            {selectedRecommender?.name ? (
                                                selectedRecommender.name
                                            ) : (
                                                <p>اختیاری</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className=" mx-3 mt-3 text-xs font-thin">
                                        <FormikInput
                                            type="text"
                                            label="لینک عضویت(برای کپی کردن کلیک کنید)"
                                            name="join_number"
                                            placeholder=""
                                            className="text-sm font-normal"
                                            value={joinLink}
                                            isGray
                                            readOnly
                                            onClick={() => {
                                                try {
                                                    navigator.clipboard
                                                        .writeText(joinLink)
                                                        .then((r) =>
                                                            toast.success(
                                                                'لینک با موفقیت کپی شد'
                                                            )
                                                        )
                                                } catch (err) {
                                                    toast.error(
                                                        'مشکلی پیش آمده!'
                                                    )
                                                    console.error(
                                                        'Failed to copy: ',
                                                        err
                                                    )
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className=" grow-0 mx-4">
                                    <button
                                        className=" w-full rounded-2xl bg-green-1 text-white py-3 my-3"
                                        type="submit"
                                    >
                                        افزودن عضو
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </Formik>
                    <SelectModal
                        show={isOpenGuarantor}
                        onHide={() => setIsOpenGuarantor(false)}
                        setSelectedUser={setSelectedGuarantor}
                        setMemberId={setGuarantorId}
                        title="انتخاب ضامن"
                    />
                    <SelectModal
                        show={isOpenRecommender}
                        onHide={() => setIsOpenRecommender(false)}
                        setSelectedUser={setSelectedRecommender}
                        setMemberId={setRecommenderId}
                        title="انتخاب معرف"
                    />
                </>
            ) : (
                <div className="w-full h-screen flex items-center justify-center">
                    <DotsLoading />
                </div>
            )}
        </>
    )
}
